// LivestreamExploreMoreModal.js
'use client';
import { connect } from 'react-redux';
import { LRUCache } from 'lru-cache';

import {
  BROWSE_EXPLORE_MORE_LIVESTREAM_POPULAR,
  BROWSE_EXPLORE_MORE_LIVESTREAM_FOLLOWING,
} from '../RemoteConfigKeys.js';
import LivestreamExploreMoreModal from '../component/LivestreamExploreMoreModal.jsx';

import getOperationData from '../selector/getOperationData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getListData from '../selector/getListData.js';
import getNetworkingData from '../selector/getNetworkingData.js';

import toggleModal from '../action/toggleModal.js';
import setShouldDisplayExploreMoreHint from '../action/setShouldDisplayExploreMoreHint.js';

import { sanitizeFeedQuery, getFeedNameType } from '../resource/feedUtils.js';

const cache = new LRUCache({ max: 8 });
const getSelectPath = category => {
  let selectPath = cache.get(category);
  if (!selectPath) {
    const sanitizedCategory = sanitizeFeedQuery({ feedName: category });
    selectPath = [
      'home',
      getFeedNameType({ feedName: sanitizedCategory }),
      'livestreamExploreMore',
      `${sanitizedCategory}`,
    ];
    cache.set(category, selectPath);
  }
  return selectPath;
};

const mapStateToProps = state => {
  const popularCategory = getRemoteConfigData(
    state,
    BROWSE_EXPLORE_MORE_LIVESTREAM_POPULAR
  );
  const followingCategory = getRemoteConfigData(
    state,
    BROWSE_EXPLORE_MORE_LIVESTREAM_FOLLOWING
  );

  const popularSelectPath = getSelectPath(popularCategory);
  const followingSelectPath = getSelectPath(followingCategory);

  const isPopularFetched = getNetworkingData(
    state,
    [...popularSelectPath, 1],
    'isFetched'
  );
  const isFollowingFetched = getNetworkingData(
    state,
    [...followingSelectPath, 1],
    'isFetched'
  );

  return {
    activeStreamId: getOperationData(state, ['liveStream'], 'activeStreamId'),
    shouldDisplayExploreMoreHint: getOperationData(
      state,
      ['liveStream'],
      'shouldDisplayExploreMoreHint'
    ),
    popularCategory,
    followingCategory,
    isPopularIdsEmpty:
      isPopularFetched &&
      !getListData(state, popularSelectPath, 'itemIds')?.length,
    isFollowingIdsEmpty:
      isFollowingFetched &&
      !getListData(state, followingSelectPath, 'itemIds')?.length,
    popularSelectPath,
    followingSelectPath,
  };
};

const mapDispatchToProps = (dispatch, { modalId }) => {
  return {
    closeModal: () =>
      dispatch(
        toggleModal({
          modalId,
          isOpen: false,
        })
      ),
    setShouldDisplayExploreMoreHint: ({ shouldDisplayExploreMoreHint }) =>
      dispatch(
        setShouldDisplayExploreMoreHint({ shouldDisplayExploreMoreHint })
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(LivestreamExploreMoreModal);
